import utils from 'utils';
import mappingConfig from './views/mappingConfig.html';
class dataSourceConfigCtrl {
    constructor(
        $scope,
        $uibModalInstance,
        httpRequest,
        logger,
        $timeout,
        itemData,
        dictData,
        $uibModal
    ) {
        utils.loading('加载中，请稍等');
        $scope.isShowAccounts = false;
        $scope.dictData = dictData;
        let timer = null;
        $scope.dataConfig = {};

        httpRequest
            .get_getDataSourcesConfigByClientId(itemData.clientId)
            .then(res => {
                let result = res.data.value || {};
                $scope.dataConfig = {
                    ...result,
                    dataClientType: result.dataClientType || '1',
                    dataDatabaseType: result.dataDatabaseType || '1',
                    kdAccountList: result.kdAccountList || [],
                };
                $timeout(() => {
                    $('.input-period').removeAttr('readonly');
                });
                $scope.dataConfig.dataClientType == 1 && getAccounts(true);
            })
            .finally(() => {
                utils.loaded();
            });

        $scope.cancel = () => {
            $uibModalInstance.close();
        };

        $scope.temporaryStore = () => {
            if (validate() === 'success') {
                utils.loading('暂存中');
                let params = {
                    ...$scope.dataConfig,
                    kdAccountList: $scope.isShowAccounts ? $scope.dataConfig.kdAccountList : [],
                };
                httpRequest
                    .post_addOrModDataSourcesConfig(params)
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.value || {};
                            $scope.dataConfig = {
                                ...$scope.dataConfig,
                                ...result,
                            };
                            logger.logSuccess('暂存成功');
                        } else {
                            logger.logError('暂存失败');
                        }
                    })
                    .finally(() => {
                        utils.loaded();
                    });
            }
        };

        $scope.autoToggleAccounts = v => {
            if (v && $scope.dataConfig.dataClientType == 1)
                $scope.dataConfig.dataDatabaseType = '1';
            if ($scope.dataConfig.dataClientType == 2) return;
            if (timer !== null) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                getAccounts();
            }, 800);
        };

        function getAccounts(noShowLoading = false) {
            if (validate(true) !== 'success') {
                utils.loaded();
                return;
            }
            if (!noShowLoading) {
                utils.loading('测试连接中');
            }
            httpRequest.post_doLinkAndInitAccountClient($scope.dataConfig).then(
                res => {
                    let kdAccountList = res.data.value || [];
                    if ($scope.dataConfig.kdAccountList.length) {
                        $scope.dataConfig.kdAccountList.forEach(i => {
                            kdAccountList.forEach(o => {
                                if (o.acctId == i.acctId) o.status = i.status;
                            });
                        });
                    } else {
                        kdAccountList.forEach(item => {
                            item.status = '1';
                        });
                    }
                    $scope.dataConfig.kdAccountList = kdAccountList;
                    $scope.isShowAccounts = kdAccountList.length > 0;
                    utils.loaded();
                },
                () => {
                    $scope.isShowAccounts = false;
                    utils.loaded();
                }
            );
        }

        $scope.testConnect = () => {
            if (validate() === 'success') {
                utils.loading('正在连接');
                httpRequest
                    .post_getDataSourcesLinkState($scope.dataConfig)
                    .then(
                        res => {
                            if (res.data.value) {
                                $scope.dataConfig.dataClientType == 1 && getAccounts(true);
                                logger.logSuccess('连接成功');
                                $scope.isConnect = true;
                            } else {
                                $scope.isShowAccounts = false;
                                logger.logError('连接失败');
                                $scope.isConnect = false;
                            }
                        },
                        () => {
                            $scope.isShowAccounts = false;
                        }
                    )
                    .finally(() => {
                        utils.loaded();
                    });
            }
        };
        $scope.initScript = () => {
            if (validate() !== 'success') {
                return;
            }
            utils.loading('正在初始化');
            httpRequest
                .post_initScript2Client($scope.dataConfig)
                .then(res => {
                    res.data.value
                        ? logger.logSuccess('客户端数据采集初始化成功')
                        : logger.logError('客户端数据采集初始化失败');
                })
                .finally(() => {
                    utils.loaded();
                });
        };
        $scope.setDataSource = () => {
            $uibModal.open({
                template: mappingConfig,
                openedClass:
                    'mod-modal-haslist mod-modal mod-modal-lg modal-invoice-title-detail mappingConfig-setting-modal',
                animation: true,
                controller: [
                    '$scope',
                    '$uibModalInstance',
                    'httpRequest',
                    'logger',
                    function ($scope, $uibModalInstance, httpRequest, logger) {
                        $scope.list = [];
                        httpRequest
                            .post_getMidTableMapping({ clientId: itemData.clientId })
                            .then(res => {
                                $scope.list = res.data.value;
                            });
                        $scope.cancel = function cancel() {
                            $uibModalInstance.close();
                        };
                        function checkHandle() {
                            let list = $scope.list;
                            for (var i = 0; i < list.length; i++) {
                                let item = list[i];
                                if (!item.tableName&&item.isRequired==1) {
                                    logger.logTips('请填写' + item.tableChName, 'warn');
                                    return false;
                                }
                                if (item.tableName.length > 50) {
                                    logger.logTips(
                                        item.tableChName + '格式不正确；最大长度为50字符',
                                        'warn'
                                    );
                                    return false;
                                }
                                let fieldDTOList = item.fieldDTOList;
                                for (var j = 0; j < fieldDTOList.length; j++) {
                                    if (
                                        !fieldDTOList[j].fieldName &&
                                        (fieldDTOList[j].isRequired == 1||(item.tableName&&(fieldDTOList[j].fieldCode==='unino'||fieldDTOList[j].fieldCode==='serial'||fieldDTOList[j].fieldCode==='invoiceno')))
                                    ) {
                                        logger.logTips(
                                            '请填写' +
                                                item.tableChName +
                                                '-' +
                                                fieldDTOList[j].fieldChName,
                                            'warn'
                                        );
                                        return false;
                                    }
                                    if (
                                        fieldDTOList[j].fieldName &&
                                        fieldDTOList[j].fieldName.length > 50
                                    ) {
                                        logger.logTips(
                                            item.tableChName +
                                                '-' +
                                                fieldDTOList[j].fieldChName +
                                                '格式不正确；最大长度为50字符',
                                            'warn'
                                        );
                                        return false;
                                    }
                                }
                            }
                            return true;
                        }
                        $scope.ok = function ok() {
                            if (checkHandle()) {
                                httpRequest.post_saveMidTableMapping($scope.list).then(res => {
                                    if (res.data.success) {
                                        logger.logSuccess('设置成功');
                                        $uibModalInstance.close();
                                    } else {
                                        logger.logError(res.data.message);
                                    }
                                });
                            }
                        };
                    },
                ],
                resolve: {},
            });
        };

        function validate(noShowError = false) {
            if (!$scope.dataConfig.dataClientType) {
                return noShowError ? 'fail' : logger.logError('客户端类型不能为空');
            }
            if (!$scope.dataConfig.dataDatabaseType) {
                return noShowError ? 'fail' : logger.logError('数据库类型不能为空');
            }
            if (!$scope.dataConfig.dataDatabaseUrl) {
                return noShowError ? 'fail' : logger.logError('数据库地址不能为空');
            }
            if (!$scope.dataConfig.dataDatabaseName) {
                return noShowError ? 'fail' : logger.logError('主数据库名不能为空');
            }
            if (!$scope.dataConfig.dataUsername) {
                return noShowError ? 'fail' : logger.logError('连接用户名不能为空');
            }
            if (!$scope.dataConfig.dataPwd && $scope.dataConfig.dataPwd !== 0) {
                return noShowError ? 'fail' : logger.logError('连接密码不能为空');
            }
            let selectedAccounts = $scope.dataConfig.kdAccountList.filter(item => {
                return item.status === '1';
            });
            if (
                !noShowError &&
                $scope.isShowAccounts &&
                selectedAccounts.length < 1 &&
                $scope.dataConfig.dataClientType != 2
            ) {
                return logger.logError('必须选择一个及以上的账套信息');
            }
            return 'success';
        }
    }
}

dataSourceConfigCtrl.$inject = [
    '$scope',
    '$uibModalInstance',
    'httpRequest',
    'logger',
    '$timeout',
    'itemData',
    'dictData',
    '$uibModal',
];
export default dataSourceConfigCtrl;



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/externalSystem/dataSourceConfigCtrl.js